module.exports = __webpack_public_path__ + "img/angle_left_small.9f6b61c7.svg";